import { Route } from "react-router-dom";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import CurrenciesPage from "@/pages/currencies/CurrenciesPage";
import CurrencyCreatePage from "@/pages/currencies/CurrencyCreatePage";
import CurrencyEditPage from "@/pages/currencies/CurrencyEditPage";

export function CurrencyRoutes() {
  return (
    <>
      <Route 
        path="currencies" 
        element={
          <ProtectedRoute>
            <CurrenciesPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="currencies/new" 
        element={
          <ProtectedRoute>
            <CurrencyCreatePage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="currencies/:id/edit" 
        element={
          <ProtectedRoute>
            <CurrencyEditPage />
          </ProtectedRoute>
        } 
      />
    </>
  );
}
